export default __webpack_public_path__ + "assets/5ef9ff523591b530cce7a4e0f4c91099.jpeg";